<template>
  <div id="map-overlay-weather" class="map-overlay-weather" :style="bindStyleVar">
      <div class="weather-time-controller">
        <vs-row vs-type="flex" vs-justify="space-between">
          <vs-col
            vs-order="1"
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="center"
            vs-lg="7"
            vs-sm="12"
            vs-xs="12"
          >
            <span class="aisea-text-20-400-white">{{ weatherCurrentDatetime }}の気象海象予測</span>
          </vs-col>
          <vs-col
            vs-order="2"
            vs-type="flex"
            vs-justify="flex-end"
            vs-align="center"
            vs-lg="5"
            vs-sm="12"
            vs-xs="12"
          >
            <switch-metocean v-show="showWeatherMenu" />
          </vs-col>
        </vs-row>
          <span v-if="!this.isTimeSyncMode" >
            <weather-time-controller/>
          </span>
      </div>
  </div>
</template>

<script>

import {createNamespacedHelpers} from "vuex";
import SwitchMetocean from "./SwitchMetocean";
import WeatherTimeController from "../components/controllers/WeatherTimeController";
import FireStoreService from "@/services/fireStoreService";

const { mapState: mapStateOfLiveMap } = createNamespacedHelpers("liveMap");

export default {
  name: "MapOverlayWeather",
  components: {
    SwitchMetocean,
    WeatherTimeController
  },
  data() {
    return {
      x: null,
      y: null,
      defaultPositionBottom: '25px',
      defaultPositionLeft: '50%',
      excludedElementFlg: false,
    };
  },
  computed: {
    ...mapStateOfLiveMap({
      showWeatherMenu: state => state.showWeatherMenu,
      weatherCurrentDatetime: state => state.weatherCurrentDatetime,
      isTimeSyncMode: state => state.isTimeSyncMode,
    }),
    bindStyleVar() {
      return {
        '--default-position-bottom': this.defaultPositionBottom,
        '--default-position-left': this.defaultPositionLeft,
      }
    },    
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
  },
  watch: {
    verticalNavMenuWidth() {
      setTimeout(() => {
        this.adjustDragElementPosition();
      }, 1200);
    },
  },
  methods: {
    /** ドラッガブル要素の初期化 */
    async initDraggableElement() {
      let draggableElement = document.getElementById("map-overlay-weather");

      const weatherTimeController = await FireStoreService.getAccountSetting('weather_time_controller');
      draggableElement.style.bottom = this.defaultPositionBottom;
      draggableElement.style.left   = this.defaultPositionLeft;
      if ( weatherTimeController && weatherTimeController.position && weatherTimeController.position.bottom ) {
        draggableElement.style.bottom = weatherTimeController.position.bottom;
      }
      if ( weatherTimeController && weatherTimeController.position && weatherTimeController.position.left ) {
        draggableElement.style.left   = weatherTimeController.position.left;
      }
      draggableElement.style.display = 'block';

      // ターゲット要素にマウスが要素内で押されたとき、又はタッチされたときのイベントを登録
      draggableElement.addEventListener("mousedown",  this.dragMouseDown, false);
      draggableElement.addEventListener("touchstart", this.dragMouseDown, false);

      // ドラッガブルが過剰に反応しないように除外エレメントを登録
      let weatherTimeControllerElement = document.getElementById("weather-time-controller");
      [
        weatherTimeControllerElement.querySelector('img'),
        weatherTimeControllerElement.querySelector('div.vue-slider'),
        document.getElementById("switch-metocean"),
      ]
      .filter(x => !!x)
      .forEach(el => {
        el.addEventListener("mousedown",  this.clickExcludedElement, false);
        el.addEventListener("touchstart", this.clickExcludedElement, { passive: false });    
      });
    },
    /** 除外エレメントが発火した時に記録しておき、抑制を促す */
    clickExcludedElement(_) {
      this.excludedElementFlg = true;
      setTimeout(() => {
        this.excludedElementFlg = false;
      }, 600);
    },
    /** ドラッガブル要素のマウスが押された時 */
    dragMouseDown(e) {
      if ( this.excludedElementFlg === true ) {
        return;
      }

      let dragElement = document.getElementById("map-overlay-weather");
      const event = (e.type === "mousedown") ? e :  e.changedTouches[0];

      // ドラッグ状態のクラス ".drag" を一時的に追加
      dragElement.classList.add("drag");

      // 要素内の相対座標を取得
      this.x = event.pageX - dragElement.offsetLeft;
      this.y = event.pageY - dragElement.offsetTop;

      // マウスムーブイベントを登録
      document.body.addEventListener("mousemove", this.dragMouseMove, false);
      document.body.addEventListener("touchmove", this.dragMouseMove, { passive: false });
      document.body.addEventListener("mouseup", this.dragMouseUp, false);
      document.body.addEventListener("touchend", this.dragMouseUp, { passive: false });
    },
    /** ドラッガブル要素のマウスカーソルが動いた時 */
    dragMouseMove(e) {
      let dragElement = document.getElementById("map-overlay-weather");
      const event = (e.type === "mousemove") ? e : e.changedTouches[0];

      // マウスが動いた場所に要素を動かす
      dragElement.style.bottom = ( document.documentElement.clientHeight - (( event.pageY - this.y ) + dragElement.offsetHeight )) + "px";
      dragElement.style.left   = ( event.pageX - this.x ) + "px";

      // マウスボタンが離されたとき、またはカーソルが外れたときのイベントを登録
      dragElement.addEventListener(   "mouseup",    this.dragMouseUp, false);
      dragElement.addEventListener(   "touchend",   this.dragMouseUp, { passive: false });
      document.body.addEventListener( "mouseleave", this.dragMouseUp, false);
      document.body.addEventListener( "touchleave", this.dragMouseUp, { passive: false });

      // フリックしたときに画面を動かさないようにデフォルト動作を抑制
      e.preventDefault();
    },
    /** ドラッガブル要素のマウスボタンが上がった時 */
    dragMouseUp(_) {
      let dragElement = document.getElementById("map-overlay-weather");

      this.adjustDragElementPosition();

      const positionData = {
        bottom: dragElement.style.bottom,
        left:   dragElement.style.left,
      };
      FireStoreService.setAccountSetting('weather_time_controller', { position: positionData });

      // イベントハンドラの消去
      dragElement.removeEventListener(   "mouseup",    this.dragMouseUp,   false);
      dragElement.removeEventListener(   "touchend",   this.dragMouseUp,   false);
      document.body.removeEventListener( "mousemove",  this.dragMouseMove, false);
      document.body.removeEventListener( "touchmove",  this.dragMouseMove, false);
      document.body.removeEventListener( "mouseleave", this.dragMouseUp,   false);
      document.body.removeEventListener( "touchleave", this.dragMouseUp,   false);

      // ドラッグ状態のクラス "".drag" を消す
      dragElement.classList.remove("drag");
    },
    /** ドラッガブル要素が枠外に出ないようにドラッグ位置の補正 */
    adjustDragElementPosition() {
      let dragElement = document.getElementById("map-overlay-weather");
      const boundaryBuffer = 30;
      const rect = dragElement.getBoundingClientRect();

      // 下補正
      if ( (rect.height + Number(dragElement.style.bottom.replace(/px$/,''))) < boundaryBuffer ){
        dragElement.style.bottom = (boundaryBuffer - rect.height) + 'px';
      }
      // 上補正
      if ( (rect.height + rect.top) < boundaryBuffer ){
        dragElement.style.bottom = (document.documentElement.clientHeight - boundaryBuffer) + 'px';
      }
      // 左補正
      if ( (rect.width / 2 + Number(dragElement.style.left.replace(/px$/,''))) < boundaryBuffer ){
        dragElement.style.left = (boundaryBuffer - rect.width / 2 ) + 'px';
      }

      // 右補正
      if ( (document.documentElement.clientWidth - rect.left) <  boundaryBuffer ){
        const leftSideBarElements = document.getElementsByClassName('header-sidebar');
        const vNavMenuBuffer = ( leftSideBarElements && leftSideBarElements.length > 0 ) ? leftSideBarElements[0].getBoundingClientRect().width : 260;
        dragElement.style.left = ( document.documentElement.clientWidth + rect.width / 2 - boundaryBuffer - vNavMenuBuffer ) + 'px';
      }
    },
    /** ドラッガブル要素位置のリセット */
    resetWeatherTimeControllerPosition() {
      let dragElement = document.getElementById("map-overlay-weather");
      dragElement.style.bottom = this.defaultPositionBottom;
      dragElement.style.left   = this.defaultPositionLeft;
      const positionData = {
        bottom: dragElement.style.bottom,
        left:   dragElement.style.left,
      };
      FireStoreService.setAccountSetting('weather_time_controller', { position: positionData });
    }
  },
  mounted() {
    this.initDraggableElement();
    let self = this;
    window.onresize = function() {
      self.adjustDragElementPosition();
    }
  },
}

</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

  .map-overlay-weather {
    display: none;
    position: absolute;
    width: 30%;
    min-width: 343px;
    max-width: 615px;
    left: var(--default-position-left);
    transform: translateX(calc(-1 * var(--default-position-left)));
    -webkit-transform: translateX(calc(-1 * var(--default-position-left)));
    bottom: var(--default-position-bottom);
    opacity: 0.9;

    @media screen and (min-width: $min-width-ipad-pro-12) {
      width: 50%;
    }
  }

  .map-overlay-weather .weather-time-controller {
    background-color: #333333;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
    border-radius: 3px;
    padding: 10px;
  }

  .drag-and-drop {
      cursor: move;
      position: absolute;
      z-index: 1000;
  }

  .drag {
      z-index: 1001;
  }

</style>